<section class="detail-notes-display" [attr.aria-labelledby]="headingId()">
    <div class="detail-notes-display__content">
        <h2 [id]="headingId()" class="detail-notes-display__title">
            {{ titleKey() | transloco }}
        </h2>
        @if (hasNote()) {
            <p class="detail-notes-display__body">{{ note() }}</p>
        } @else {
            <p class="detail-notes-display__body detail-notes-display__body--empty"></p>
        }
    </div>
</section>
